import { render, staticRenderFns } from "./TrafficViolationList.vue?vue&type=template&id=5327c579"
import script from "./TrafficViolationList.vue?vue&type=script&lang=js"
export * from "./TrafficViolationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports